import usePokemonSprites from '../../hooks/usePokemonSprites';
import './Matchup.css';

export default function Matchup({ matchupData = {} }) {
  const allPokemon = [
    ...matchupData.player1.team,
    ...matchupData.player2.team,
  ]
    .filter((p) => p && p.trim() !== '');

  const { sprites, loading } = usePokemonSprites(allPokemon);

  const renderPokemonTeam = (team) => {
    return (
      <div className="matchup__team">
        {team
          .filter((p) => p && p.trim() !== '')
          .map((pokemon, idx) => {
            const spriteUrl = sprites[pokemon.toLowerCase().trim()];
            return (
              <div key={idx} className="matchup__pokemon">
                {spriteUrl ? (
                  <img
                    src={spriteUrl}
                    alt={pokemon}
                    className="matchup__sprite"
                    loading="lazy"
                  />
                ) : (
                  <div className="matchup__sprite-placeholder">?</div>
                )}
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div className="matchup-container">
      {/* Header with tournament and round info */}
      <div className="matchup__header">
        {matchupData.tournamentName && (
          <h2 className="matchup__tournament-name honk-title">
            {matchupData.tournamentName}
          </h2>
        )}
        {matchupData.roundName && (
          <p className="matchup__round-name chiron-goround-tc-light">
            {matchupData.roundName}
          </p>
        )}
      </div>

      {/* Main matchup container */}
      <div className="matchup__content">
        {/* Player 1 */}
        <div className="matchup__player matchup__player--1">
          <div className="matchup__player-header">
            <h3 className="matchup__player-name staatliches-regular">
              {matchupData.player1.name}
            </h3>
            {matchupData.player1.score && (
              <div className="matchup__player-score">
                {matchupData.player1.score}
              </div>
            )}
          </div>
          {renderPokemonTeam(matchupData.player1.team)}
        </div>

        {/* VS separator */}
        <div className="matchup__vs">
          <span className="matchup__vs-text honk-title">vs.</span>
        </div>

        {/* Player 2 */}
        <div className="matchup__player matchup__player--2">
          <div className="matchup__player-header">
            <h3 className="matchup__player-name staatliches-regular">
              {matchupData.player2.name}
            </h3>
            {matchupData.player2.score && (
              <div className="matchup__player-score">
                {matchupData.player2.score}
              </div>
            )}
          </div>
          {renderPokemonTeam(matchupData.player2.team)}
        </div>
      </div>
    </div>
  );
}
